var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMissionSvg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.2229 12.344C47.9099 11.9267 47.5041 11.588 47.0375 11.3547C46.571 11.1214 46.0565 11 45.5349 11H18.6547C18.1331 11 17.6186 11.1214 17.152 11.3547C16.6855 11.588 16.2796 11.9267 15.9667 12.344L8.49172 22.3142C8.03809 22.9195 7.80192 23.66 7.82143 24.4161C7.84094 25.1722 8.11499 25.8996 8.59924 26.4806L29.5165 51.7927C29.8319 52.1692 30.226 52.4721 30.6711 52.6799C31.1161 52.8877 31.6013 52.9954 32.0925 52.9954C32.5837 52.9954 33.0689 52.8877 33.514 52.6799C33.9591 52.4721 34.3532 52.1692 34.6686 51.7927L55.5858 26.4806C56.0701 25.8996 56.3441 25.1722 56.3636 24.4161C56.3832 23.66 56.147 22.9195 55.6934 22.3142L48.2229 12.344Z",
    stroke: "#6263AB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M17.1139 11.3741L32.0951 53L47.0749 11.3741M7.81641 24.44H56.3643M22.0159 24.44L32.0959 11L42.176 24.44",
    stroke: "#6263AB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissionSvg);
export default __webpack_public_path__ + "static/media/missionSVG.a56518deef544e35f245f9acc0725383.svg";
export { ForwardRef as ReactComponent };